import React, {useRef} from 'react';

import {ScrollArea} from '@/components/ScrollArea/ScrollArea';
import useIsDesktopLayout from '@/hooks/layout/useIsDesktopLayout';
import {twx} from '@/utils/tailwindUtils';

import useDeviceSettingsScrollToTop from './useDeviceSettingsScrollToTop';

const DevicesSettingsSectionWrapper = ({className, children}) => {
    const isDesktop = useIsDesktopLayout();
    const viewportRef = useRef(null);

    useDeviceSettingsScrollToTop(viewportRef);

    return isDesktop ? (
        <ScrollArea
            className={twx(
                'flex w-full max-w-[700px] flex-[1.36] flex-col rounded-b-none rounded-t-[30px] bg-white lg:flex-[1.47]',
                className
            )}
            viewportRef={viewportRef}
            viewportClassName='snap-y snap-proximity [&>div]:h-full [&>div]:table-fixed'
        >
            {children}
        </ScrollArea>
    ) : (
        <section className={twx('flex w-full flex-col overflow-hidden rounded-xl bg-primary-dark-5', className)}>
            {children}
        </section>
    );
};

export default DevicesSettingsSectionWrapper;
